<template>
    <div id="app">
        <Main :language="language" />
    </div>
</template>

<script>
import Main from './components/Main'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    components: {
        Main
    },
    data() {
        return {
            language: 'en'
        }
    },

    created() {
        this.initLANG()

        ;(function (doc, win) {
            var docEl = doc.documentElement,
                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                recalc = function () {
                    var clientWidth = docEl.clientWidth

                    if (!clientWidth) return
                    if (clientWidth < 1200) {
                        docEl.style.fontSize = 16 * (clientWidth / 720) + 'px'
                        if (clientWidth > 1023) {
                            docEl.style.fontSize = '18px'
                        }
                    } else {
                        docEl.style.fontSize = '18px'
                    }
                }
            if (!doc.addEventListener) return
            win.addEventListener(resizeEvt, recalc, false)
            doc.addEventListener('DOMContentLoaded', recalc, false)
        })(document, window)
    },
    methods: {
        initLANG() {
            let language = navigator.language.toLowerCase()
            if (parsed.gameLanguage) {
                language = parsed.gameLanguage
            }
            if (language.startsWith('zh')) {
                this.language = 'zh-TW'
            } else if (language.startsWith('ja')) {
                this.language = 'ja'
            } else if (language.startsWith('ko')) {
                this.language = 'ko'
            } else {
                this.language = 'en'
            }
        }
    }
}
</script>

<style>
html,
body {
    min-height: 100%;
    text-align: center;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
@media screen and (min-width: 1024px) {
    #app {
        background: url('~@/assets/images/pc/bg.png') no-repeat center top;
        background-size: 100% auto;
        min-height: 100vh;
    }
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
}

a {
    text-decoration: none;
    color: #232323;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
</style>
